import React, { useState, useEffect } from "react";
import "./Header.css";
import { Menu, X } from "lucide-react";

import Logo from "../assets/headerLogo.png";

const navItems = [
  { label: "Quem Somos", href: "#quem-somos" },
  { label: "Quem Atendemos", href: "#atuacao" },
  { label: "Cases de Sucesso", href: "#cases" },
  { label: "FAQ", href: "#faq" },
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const handleLinkClick = () => {
    if (mobileMenuOpen) setMobileMenuOpen(false);
  };

  return (
    <header
      className={`header ${isScrolled || mobileMenuOpen ? "scrolled" : ""}`}
    >
      <div className="container">
        <div className="header-content">
          <img src={Logo} alt="Profile" className="logo" />

          <nav className="nav-desktop">
            {navItems.map((item) => (
              <a key={item.label} href={item.href} className="nav-link">
                {item.label}
              </a>
            ))}
            <a href="#contato" className="btn">
              Fale Conosco
            </a>
          </nav>

          <button className="menu-toggle" onClick={toggleMobileMenu}>
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="mobile-menu">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={handleLinkClick}
              className="mobile-link"
            >
              {item.label}
            </a>
          ))}
          <a href="#contato" className="btn" onClick={handleLinkClick}>
            Fale Conosco
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
